import { Dayjs } from 'dayjs'
import { FieldStore } from './FieldStore'

export const required =
  (msg?: string) =>
  <T>(val: T) =>
    val === null || val === 0 || val === '' || val === undefined
      ? msg ?? 'fieldIsRequired'
      : undefined

export const requiredArray = (val?: any[] | null): string | undefined => {
  if (!Array.isArray(val) || val.length === 0) {
    return 'fieldIsRequired'
  }
  return undefined
}

export const requiredDate = (msg?: string) => (val: Dayjs | null) =>
  val === null || !val.isValid() ? msg ?? 'fieldIsRequired' : undefined

export const validateCarrierTypes = (
  inbound: FieldStore<string> | undefined,
  outbound: FieldStore<string> | undefined,
): boolean => {
  if (!inbound || !outbound) {
    return true
  }

  const isInboundUnknown = inbound.value === 'Universal'
  const isOutboundUnknown = outbound.value === 'Universal'
  const isInboundEmpty = !inbound.value
  const isOutboundEmpty = !outbound.value

  inbound.touch()
  outbound.touch()

  if (isInboundEmpty && isOutboundEmpty) {
    inbound.setError('fieldIsRequired')
    outbound.setError('fieldIsRequired')
    return false
  }

  if (isInboundUnknown && isOutboundUnknown) {
    inbound.setError('cannotSelectBothUnknown')
    outbound.setError('cannotSelectBothUnknown')
    return false
  }

  if (isInboundUnknown && isOutboundEmpty) {
    outbound.setError('fieldIsRequired')
    inbound.setError(undefined)
    return false
  }
  if (isOutboundUnknown && isInboundEmpty) {
    inbound.setError('fieldIsRequired')
    outbound.setError(undefined)
    return false
  }

  inbound.setError(undefined)
  outbound.setError(undefined)
  return true
}

export const mustBeGreaterThan = (val: number, min = 0) =>
  val < min ? 'valueMustBeGreaterThan' : undefined

export const mustBeLessThan = (val: number, max: number) =>
  val > max ? 'valueMustBeLessThan' : undefined

export const optional = () => undefined
